
import Button from './Button'
import { ReactNode } from 'react';
type ToastMessage = {
    success?: string,
    cancel?: string,
    error?: string
}
const PrimaryButton = (props: {
    loading?: boolean;
    isDisabled?: any;
    onClick?: any;
    value: any;
    classes?: string;
    isDisabledWithoutAnimation?: any;
    icon?: any;
    confirmationMessage?: string;
    hideToastMessages?: boolean
    toastMessages?: ToastMessage
    svg?: ReactNode
    isSubmitButton?: boolean

}) => {
    const { classes } = props;


    return (
        <Button {...{ ...props, classes: classes + " py-2 px-4 flex items-center justify-center bg-[#7059EF] hover:bg-[#5841D9] rounded text-[#FFFFFF] disabled:bg-[#c5bfff]  cursor-pointer disabled:cursor-not-allowed" }} ></Button>
    );
};

export default PrimaryButton;

